var supercool = new Vue({
  el: '#collection-products',
  delimiters: ['<%', '%>'],
  name: 'Collection',
  components: {
    VSelect: VueSelect.VueSelect,
  },
  data() {
    return {
      products: [],
      metafields: [],
    };
  },
  created() {
    const promises = [];
    promises.push(
      axios
        .get(window.location.pathname + '?view=default_json')
        .then((response) => {
          this.products = this.products.concat(response.data);
        })
    );
    promises.push(
      axios
        .get(window.location.pathname + '?view=default_json&page=2')
        .then((response) => {
          this.products = this.products.concat(response.data);
        })
    );
    promises.push(
      axios
        .get(window.location.pathname + '?view=for_json')
        .then((response) => {
          this.metafields = this.metafields.concat(response.data);
        })
    );
    promises.push(
      axios
        .get(window.location.pathname + '?view=for_json&page=2')
        .then((response) => {
          this.metafields = this.metafields.concat(response.data);
        })
    );
    Promise.all(promises).then(() => {
      this.products = _.map(this.products, (product) => {
        return _.merge(product, this.metafieldsById(product.id), {
          chosenVariant: product.variants[0],
        });
      });
      this.$nextTick(initTooltip);
    });
  },
  computed: {
    groupedProducts() {
      return _.groupBy(this.products, (product) => {
        if (product.Informations && product.Informations.year) {
          return product.Informations.year;
        }
        return moment().year().toString();
      });
    },
    groupedProductsSortedKeys() {
      return _.reverse(_.sortBy(Object.keys(this.groupedProducts)));
    },
    myProducts() {
      return _.filter(this.products, 'my_collection');
    },
  },
  methods: {
    imgSize(imgUrl, size) {
      if (imgUrl) {
        return imgUrl.replace(
          /(\/[a-zA-Z]+)(\.[a-zA-Z]+\?)/,
          '$1_' + size + '$2'
        );
      }
    },
    addProduct(product) {
      axios
        .post('/cart/add.js', { items: [{ id: product.chosenVariant.id }] })
        .then(() => {
          axios.get('/cart.js').then((response) => {
            topCart.cart = response.data;
          });
          mainToast.text = 'Votre article a été ajouté au panier !';
          mainBsToast.show();
        });
    },
    metafieldsById(id) {
      return _.find(this.metafields, { id: id });
    },
    updateVariant(product, val) {
      const index = _.findIndex(this.products, { id: product.id });
      const newValue = Object.assign({}, product, { chosenVariant: val });
      this.$set(this.products, index, newValue);
    },
  },
});
